import { render, staticRenderFns } from "./ModalRoot.vue?vue&type=template&id=625e4d3e&"
import script from "./ModalRoot.vue?vue&type=script&lang=ts&"
export * from "./ModalRoot.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports